import { render, staticRenderFns } from "./ForegroundReverse.vue?vue&type=template&id=01c922b4&"
import script from "./ForegroundReverse.vue?vue&type=script&lang=js&"
export * from "./ForegroundReverse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports